import { PatchNotesService } from '../PatchNotesService';
import { PatchNotes as PatchNotesState } from '../entity';
import { PatchNotesEntry } from '../patchNotes';

export interface CurrentPatchNotesState {
  patchNotes?: PatchNotesState;
  selectedVersion?: string;
  needsAcknowledgement: boolean;
  shouldOpenDialog: boolean;
}

export class PatchNotesStateService {
  private readonly patchNotesService = new PatchNotesService();

  getList(): PatchNotesEntry[] {
    return this.patchNotesService.getList();
  }

  async loadCurrent(): Promise<CurrentPatchNotesState | undefined> {
    const currentPatchNotes = this.patchNotesService.getCurrent();

    if (!currentPatchNotes) {
      return undefined;
    }

    const patchNotes = await this.patchNotesService.load(
      currentPatchNotes,
      !this.patchNotesService.hasSeen(currentPatchNotes)
    );

    return {
      patchNotes,
      selectedVersion: currentPatchNotes.version,
      needsAcknowledgement: patchNotes.should_show,
      shouldOpenDialog: patchNotes.should_show
    };
  }

  async loadVersion(
    version: string,
    needsAcknowledgement: boolean
  ): Promise<CurrentPatchNotesState | undefined> {
    const entry = this.patchNotesService.getEntry(version);
    const currentPatchNotes = this.patchNotesService.getCurrent();

    if (!entry) {
      return undefined;
    }

    const shouldShow =
      entry.version === currentPatchNotes?.version && needsAcknowledgement;
    const patchNotes = await this.patchNotesService.load(entry, shouldShow);

    return {
      patchNotes,
      selectedVersion: entry.version,
      needsAcknowledgement,
      shouldOpenDialog: shouldShow
    };
  }

  async loadCurrentVersion(
    needsAcknowledgement: boolean
  ): Promise<CurrentPatchNotesState | undefined> {
    const currentPatchNotes = this.patchNotesService.getCurrent();

    if (!currentPatchNotes) {
      return undefined;
    }

    return this.loadVersion(currentPatchNotes.version, needsAcknowledgement);
  }

  acknowledgeIfNeeded(needsAcknowledgement: boolean) {
    const currentPatchNotes = this.patchNotesService.getCurrent();

    if (currentPatchNotes && needsAcknowledgement) {
      this.patchNotesService.markSeen(currentPatchNotes);
    }
  }
}
